












































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GPageBase } from '@/mixins';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { required, email, between } from 'vuelidate/lib/validators';
import { StringUtils } from '@/utils/string.utils';
import { Tag } from '@/models/tag';
import { Student } from '@/models/student/student';
import { studentModule } from '@/store/modules/entities/student.module';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { tagModule } from '@/store/modules/entities/tag.module';

import { SchoolClass } from '@/models/school-class/school-class';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GVTag from '@/components/GVTag.vue';
import { cookieService } from '@/service/cookie.service';
import { Header } from '@/constants/constants';
import { GetStudentRequest } from '@/models/student/get-student-request';
import { ExistStudentResponse } from '@/models/student/exist-student-response';
import GStudentRecordItemCell from '@/views/GStudentRecord/GStudentRecordItemCell.vue';
import GStudentRecordValueCell from '@/views/GStudentRecord/GStudentRecordValueCell.vue';
import GNoDataSpan from '@/components/GNoDataSpan.vue';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GStudents',
  components: {
    GNoDataSpan,
    GStudentRecordValueCell,
    GStudentRecordItemCell,
    GVTag,
    GTitleBar,
    GCustomBreadCrumb,
  },
  methods: {},
  validations: {
    student: {
      firstName: { required },
      lastName: { required },
      firstNameKana: { required },
      lastNameKana: { required },
      schoolClass: { required },
      email: { email },
      manageNumber: { between: between(0, 999999) },
    },
    password: { required },
    passwordConfirm: { required },
  },
})
export default class GStudentEdit extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  passwordModal: boolean = false;
  tagInput: string = '';
  password: string = '';
  passwordConfirm: string = '';
  studentID: number;
  isDeleteConfirm: boolean = false;
  modalLastYearInfo: boolean = false;
  isLastYearStudent: boolean = false; // 昨年度生徒存在チェックフラグ
  fullName: string = '';
  priorityTagName: string = '';
  showTagWarningModal: boolean = false;

  async mounted() {
    this.studentID = parseInt(this.$route.params['id']);
    this.breadCrumbItems = [
      { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' },
      { title: this.$t('REGISTERED_PERSON_INFORMATION').toString(), routerPath: '/pages/students' },
      { title: this.$t('TEACHER_EDIT_LINK').toString() },
    ];

    schoolClassModule.fetchSchoolClasses();
    await studentModule.getStudent({ studentID: this.studentID } as GetStudentRequest);

    if (this.student.priorityTag) {
      this.priorityTagName = this.student.priorityTag.tagContent;
    }
    this.fullName = this.student.fullName;
    const headers = { [Header.SchoolYear]: globalModule.selectedSchoolYear - 1 };
    studentModule.existStudent({ studentID: this.studentID, headers: headers }).then((response: ExistStudentResponse) => {
      if (response.exist) {
        studentModule.getStudent({ studentID: this.studentID, isLastYear: true, headers: headers } as GetStudentRequest);
        this.isLastYearStudent = true;
      }
    });
    tagModule.fetchTags().then(() => {
      this.tags.map((masterTag: Tag) => {
        this.student.tag.forEach((studentTag: Tag) => {
          if (studentTag.tagID === masterTag.tagID) {
            masterTag.flg = true;
          }
        });
      });
    });
  }

  get nameOrder(): boolean {
    return this.$store.state.currentLanguage.nameOrder;
  }

  get lastSchoolYear(): number {
    return globalModule.selectedSchoolYear - 1;
  }

  get isFirstNameInvalid(): boolean {
    return this.$v.student.firstName.$dirty && this.$v.student.firstName.$invalid;
  }

  get isLastNameInvalid(): boolean {
    return this.$v.student.lastName.$dirty && this.$v.student.lastName.$invalid;
  }

  get isFirstKanaInvalid(): boolean {
    return this.$v.student.firstNameKana.$dirty && this.$v.student.firstNameKana.$invalid;
  }

  get isLastKanaInvalid(): boolean {
    return this.$v.student.lastNameKana.$dirty && this.$v.student.lastNameKana.$invalid;
  }

  get isSelectClassInvalid(): boolean {
    return this.$v.student.schoolClass.$dirty && this.$v.student.schoolClass.$invalid;
  }

  get isManageNumberInvalid(): boolean {
    return this.$v.student.manageNumber.$dirty && this.$v.student.manageNumber.$invalid;
  }

  get isEmailInvalidFormat(): boolean {
    return this.$v.student.email.$dirty && this.$v.student.email.email == false;
  }

  get isRoleIgsAdmin(): boolean {
    return this.$store.state.account.isRoleIgsAdmin;
  }

  get tags(): Tag[] {
    return tagModule.tags;
  }

  get student(): Student {
    return studentModule.student;
  }

  get lastYearStudent(): Student {
    return studentModule.lastYearStudent;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses;
  }

  makeFormTouched() {
    this.$v.student.lastName.$touch();
    this.$v.student.firstName.$touch();
    this.$v.student.firstNameKana.$touch();
    this.$v.student.lastNameKana.$touch();
    this.$v.student.email.$touch();
    this.$v.student.schoolClass.$touch();
    this.$v.student.manageNumber.$touch();
  }

  get isFormInvalid() {
    return this.isLastNameInvalid || this.isFirstNameInvalid || this.isLastKanaInvalid || this.isFirstKanaInvalid || this.isSelectClassInvalid || this.isEmailInvalidFormat || this.isManageNumberInvalid;
  }

  handleCommitStudent() {
    this.makeFormTouched();
    if (this.isFormInvalid) {
      return;
    }
    if (this.tagInput !== '') {
      this.showTagWarningModal = true;
      return;
    }

    this.student.selectedTagContents = this.selectedTagContents;

    studentModule.updateStudent(this.priorityTagName).then(
      (_) => {
        this.showUpdateSuccessed();
      },
      (_) => {
        this.showUpdateFailed();
      }
    );
  }

  handleDeleteStudent() {
    let config = {
      title: this.$t('CONFIRM_DELETE_STUDENT', {value: this.student.fullName}).toString(),
      onOk: () => {
        this.loadingPage(
          () => {
            studentModule.deleteStudent(this.student.studentID);
          },
          () => {
            this.$router.push('/pages/students');
            this.showDeleteSuccessed();
          }
        );
      },
      onCancel: () => {
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  get selectedTagContents(): string[] {
    return tagModule.selectedTagContents;
  }

  handleClose(event: any, name: string): void {
    tagModule.deleteTag(name);
  }

  handleAddTag(): void {
    if (this.tagInput === '') return;
    if (this.checkOverlapTag(this.tagInput)) {
      this.tagInput = '';
      return;
    }

    const newTag = new Tag().deserialize({ tagID: 0, tag: this.tagInput, isClosable: true, flg: true });
    tagModule.addTag(newTag);
    this.tagInput = '';
  }

  checkOverlapTag(newTagContent: string): boolean {
    return this.tags.some((tag: Tag): boolean => {
      if (tag.tagContent === newTagContent) {
        tag.flg = true;
        return true;
      } else {
        return false;
      }
    });
  }

  get isEmptyPassword(): boolean {
    return this.$v.password.$dirty && this.$v.password.$invalid;
  }

  get isPasswordOutOfRange(): boolean {
    return this.$v.password.$dirty && this.$v.password.$invalid == false && StringUtils.isValidPassword(this.password) == false;
  }

  get isEmptyPasswordConfirm(): boolean {
    return this.$v.passwordConfirm.$dirty && this.$v.passwordConfirm.$invalid;
  }

  get isDifferentPassword(): boolean {
    return this.isEmptyPassword === false && this.isEmptyPasswordConfirm === false && this.password !== this.passwordConfirm;
  }

  get isChangePasswordInvalid(): boolean {
    return this.isEmptyPassword || this.isPasswordOutOfRange || this.isEmptyPasswordConfirm || this.isDifferentPassword;
  }

  changePassword() {
    this.$v.password.$touch();
    this.$v.passwordConfirm.$touch();

    if (this.isChangePasswordInvalid) {
      return;
    }
    studentModule.updatePassword(this.password).then((response: any) => {
      this.showUpdateSuccessed();
      this.passwordModal = false;
      this.password = '';
      this.passwordConfirm = '';
    });
  }

  handleClickTag(tag: Tag) {
    tag.flg = !tag.flg;
    if (!tag.flg && this.priorityTagName === tag.tagContent) {
      this.priorityTagName = '';
    }
  }

  goToStudentManagement() {
    this.$router.push({ name: 'students' });
  }
}
